const actionsType = {
    GET_PRODUCTS: 'GET_PRODUCTS',
    GET_PRODUCTS_SKU: 'GET_PRODUCTS_SKU',
    GET_SEARCH_PRODUCTS: 'GET_SEARCH_PRODUCTS',
    GET_SHELF_PRODUCTS: 'GET_SHELF_PRODUCTS',
    GET_PRODUCT: 'GET_PRODUCT',

    GET_CART: 'GET_CART',
    ADD_ITEM_CART: 'ADD_ITEM_CART',
    REMOVE_ITEM_CART: 'REMOVE_ITEM_CART',
    CART_LOADING: 'CART_LOADING',
    CLEAR_CART: 'CLEAR_CART',
    UPDATE_CART: 'UPDATE_CART',
    SET_CUPON: 'SET_CUPON',
    SET_PAYMENT: 'SET_PAYMENT',
    SET_SHIPPING_DATA: 'SET_SHIPPING_DATA',
    SET_PROFILE_DATA: 'SET_PROFILE_DATA',
    GET_ORDER_INFO: 'GET_ORDER_INFO',
    SET_ORDER_INFO: 'SET_ORDER_INFO',

    SET_RECEIVER_DATA: 'SET_RECEIVER_DATA',
    GET_USER_INFO: 'get_user_info',

    MODAL: {
        VALIDATION_CODE_OPEN: 'validation_code_open',
        VALIDATION_CODE_CLOSE: 'validation_code_close',
        CRITERIA_SUBSTITUTION_OPEN: 'modal_criteria_substitution_open',
        CRITERIA_SUBSTITUTION_CLOSE: 'modal_criteria_substitution_close',
        DELIVERY_SELECTOR_OPEN: 'delivery_selector_open',
        DELIVERY_SELECTOR_CLOSE: 'delivery_selector_close',
        ADD_NOTES_OPEN: 'add_notes_open',
        ADD_NOTES_CLOSE: 'add_notes_close',
        FAILED_PAYMENT_OPEN: 'failed_payment_open',
        FAILED_PAYMENT_CLOSE: 'failed_payment_close',
        ADD_TO_LIST_OPEN: 'add_to_list_open',
        ADD_TO_LIST_CLOSE: 'add_to_list_close',
        CONFIRMATION_OPEN: 'modal_confirmation_open',
        CONFIRMATION_CLOSE: 'modal_confirmation_close',
        PRODUCTS_CART_OPEN: 'cart_products_open',
        PRODUCTS_CART_CLOSE: 'cart_products_close',
        LOGIN_OPEN: 'login_open',
        LOGIN_CLOSE:'login_close',
        FEEDBACK_REGISTER_OPEN: 'modal_feedback_register_open',
        FEEDBACK_REGISTER_CLOSE: 'modal_feedback_register_close',
        PRODUCTS_LOST_OPEN: 'lost_products_open',
        PRODUCTS_LOST_CLOSE: 'lost_products_close',
        CREATE_NEW_LIST_OPEN: 'create_new_list_open',
        CREATE_NEW_LIST_CLOSE: 'create_new_list_close',
        PRODUCT_IN_CART_OPEN: 'modal_product_in_cart_open',
        PRODUCT_IN_CART_CLOSE: 'modal_product_in_cart_close',
        PASSWORD_OPEN: 'forgot_password_open',
        PASSWORD_CLOSE: 'forgot_password_close',
        DATE_DELIVERY_OPEN: 'modal_date_delivery_open',
        DATE_DELIVERY_CLOSE: 'modal_date_delivery_close',
        SCHOOLS_INSCRIPTION_OPEN: 'inscription_list_open',
        SCHOOLS_INSCRIPTION_CLOSE: 'inscription_list_close',
        REGISTER_OPEN: 'register_open',
        REGISTER_CLOSE: 'register_close',
        SUGGESTED_PRODUCT_OPEN: 'suggested_product_open',
        SUGGESTED_PRODUCT_CLOSE: 'suggested_product_close',
        PERSISTS_ADDRESS_OPEN: 'modal_persist_address_open',
        PERSISTS_ADDRESS_CLOSE: 'modal_persist_address_close',
        ADDRESS_OPEN: 'address_open',
        ADDRESS_CLOSE: 'address_close',
        EDIT_USER_OPEN: 'edit_user_open',
        EDIT_USER_CLOSE: 'edit_user_close',
        NEW_FEATURE_OPEN: 'new_feature_open',
        NEW_FEATURE_CLOSE: 'new_feature_close',
        ADD_CARDS_OPEN: 'add_cards_open',
        ADD_CARDS_CLOSE: 'add_cards_close',
        RECEIVER_DATA_OPEN: 'receiver_data_open',
        RECEIVER_DATA_CLOSE: 'receiver_data_close',
        UPDATE_CLIENT_OPEN: 'update_client_open',
        UPDATE_CLIENT_CLOSE: 'update_client_close',
        RESCHEDULE_ALERT_OPEN: 'reschedule_alert_open',
        RESCHEDULE_ALERT_CLOSE: 'reschedule_alert_close',
        RESCHEDULE_CONFIRM_OPEN: 'reschedule_confirm_open',
        RESCHEDULE_CONFIRM_CLOSE: 'reschedule_confirm_close',
        ORDER_CANCEL_SUCCESS_OPEN: 'order_cancel_success_open',
        ORDER_CANCEL_SUCCESS_CLOSE: 'order_cancel_success_close',
        TERMS_AND_CONDITIONS_OPEN: 'terms_and_conditions_open',
        TERMS_AND_CONDITIONS_CLOSE: 'terms_and_conditions_close'

    },
    SET_SALES_CHANNEL: 'set_sales_channel',
    LOGGED_IN: 'logged_in'
};

const pages = {
    home: 2662,
    school: 11140
};

const translateIcons = {
    'cat-electro-y-tecnologia': 'jumbo-icon-category-electro-y-tecnologia',
    'cat-jugueteria': 'jumbo-icon-category-jugueteria',
    'cat-libreria': 'jumbo-icon-category-libreria',
    'cat-mi-bebe': 'jumbo-icon-category-mi-bebe',
    'cat-deportes': 'jumbo-icon-category-deportes'
};

const translateFlag = {
    'Si': true,
    'No': false
}

const translateRegions ={
    'REGIÓN METROPOLITANA' :'Región Metropolitana',
    'V REGIÓN':'Región de Valparaíso',
    'IV REGIÓN':'Región de Coquimbo',
    'II REGIÓN':'Región de Antofagasta',
    'I REGIÓN':'Región de Tarapacá',
    'III REGIÓN':'Región de Atacama',
    'VI REGIÓN':'Región de O\'Higgins',
    'VII REGIÓN':'Región del Maule',
    'VIII REGIÓN':'Región del Bío Bío',
    'IX REGIÓN':'Región de La Araucanía',
    'X REGIÓN':'Región de Los Lagos',
    'XIV REGIÓN':'Región de Los Ríos',
    'XV REGIÓN':'Región de Arica y Parinacota'
}

const translateMethodStatus = {
    'store_pickup': 'Retiro en Tienda',
    'drive_through':'Click al Auto',
    'express_delivery':'Despacho a Domicilio',
    'delivery': 'Despacho a Domicilio'
}

export {
    actionsType,
    pages,
    translateIcons,
    translateFlag,
    translateRegions,
    translateMethodStatus
};

